export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks1.9ab4b199.png";